import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "score__overview" }

import Vue3autocounter from 'vue3-autocounter';
import { getRandomEmojis } from '@/utils/dialogHelper';
import { useUserStore } from '@/stores/userStore';
import { computed } from 'vue';
import ProgressComponent from '@/components/ProgressComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RoundPoints',
  setup(__props) {

const userStore = useUserStore();

const score = computed(() => userStore.currentRound?.score);
const won = computed(() => userStore.currentRound?.survived);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProgressComponent, {
      autoStart: "",
      value: score.value,
      variant: won.value ? 'success' : 'error',
      duration: 1500
    }, null, 8, ["value", "variant"]),
    _createVNode(_unref(Vue3autocounter), {
      ref: "counter",
      class: "score__counter",
      startAmount: 0,
      endAmount: score.value,
      duration: 1.5,
      separator: "",
      autoinit: true,
      suffix: _unref(getRandomEmojis)(won.value)
    }, null, 8, ["endAmount", "suffix"])
  ]))
}
}

})